const faNumber = new Intl.NumberFormat("fa-IR");
const faDate = new Intl.DateTimeFormat("fa-IR", { dateStyle: "medium", timeStyle: "short" });

export const money = (value: number) => `${faNumber.format(value)} تومان`;
export const number = (value: number) => faNumber.format(value);
export const dateTime = (value?: string | null) => (value ? faDate.format(new Date(value)) : "—");
export const nullableNumber = (value: FormDataEntryValue | null) => {
  const text = String(value ?? "").trim();
  return text ? Number(text) : null;
};
export const slugify = (value: string) =>
  value.trim().toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "").replace(/-+/g, "-").replace(/^-|-$/g, "");
